import { createImageUrlBuilder } from '@sanity/image-url';
import type { Image as SanityImageSource } from 'sanity';
import { client } from './client';

const builder = createImageUrlBuilder(client);

export function urlFor(source?: SanityImageSource | null) {
  if (!source) return undefined;
  return builder.image(source);
}

// Convenience: resolve straight to a {src, alt} pair for components/ui/AppImage.tsx,
// falling back to a placeholder path so a missing image never crashes rendering.
export function imageWithAlt(
  image: (SanityImageSource & { alt?: string }) | null | undefined,
  fallbackAlt = ''
): { src: string; alt: string } {
  const src = urlFor(image)?.url();
  return {
    src: src || '/assets/images/no_image.png',
    alt: image?.alt || fallbackAlt,
  };
}
